import { render, staticRenderFns } from "./VideoConfigPanel.vue?vue&type=template&id=4382396f&scoped=true"
import script from "./VideoConfigPanel.vue?vue&type=script&lang=js"
export * from "./VideoConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./VideoConfigPanel.vue?vue&type=style&index=0&id=4382396f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4382396f",
  null
  
)

export default component.exports